import React, { useState } from 'react';
import { string, bool, object } from 'prop-types';
import { get, last } from 'lodash';
import { DrawerHeader, Drawer, Column, AlertLabel, Loading, Text, Button, Row } from '../../common';
import { _get } from '../../../utils/misc';
import OrderQr from './OrderQr';
import QueryOrderQr from '../../graphql/getOrderQrById';
import { getQrStatusValues } from '../../../utils/misc';
import { withFirebase } from '../../../hoc';
import useOrderNotification34 from './useOrderNotification34';

const OrderQrStatus = ({ numOrder, id, storeName, isBipicking, relatedOrderId, firebase }) => {
    const errorStatus = getQrStatusValues('error');  
    const successStatus = getQrStatusValues('success');
    const expiredStatus = [3]; // time expired
    const [drawerOrderQr, setDrawerOrderQr] = useState(false);
    const [optimisticUnlocked, setOptimisticUnlocked] = useState(false);
    const { wasUnlocked: firebaseUnlocked } = useOrderNotification34(firebase, id);
    const wasUnlocked = optimisticUnlocked || firebaseUnlocked;
    const handleUnlocked = () => setOptimisticUnlocked(true);

    const closeDrawerOrderQr = () => setDrawerOrderQr(false);
    const toggleDrawerOrderQr = () => setDrawerOrderQr(!drawerOrderQr);

    const getDrawerOrderQrTitle = (actionNumber) => {
        if (successStatus.includes(actionNumber)) return 'Detalle desbloqueo de puerta';
        if (errorStatus.includes(actionNumber) && wasUnlocked) return 'Detalle desbloqueo de puerta';
        if (errorStatus.includes(actionNumber)) return 'Desbloquear puerta';
        return 'QR sin datos';
    };

    const renderAlertButton = (actionNumber) => {
        if (!actionNumber || actionNumber === 0) {
            return <AlertLabel text='Sin validación' width='130px' />;
        }
        if (successStatus.includes(actionNumber)) {
            return <AlertLabel type="success" text="QR Exitoso" width='130px' />;
        }
        if (errorStatus.includes(actionNumber) && wasUnlocked) {
            return <AlertLabel type="success" text="Desbloqueada" width='130px' />;
        }
        if (expiredStatus.includes(actionNumber)) {
            return <AlertLabel type='error' text='QR Expirado' width='130px' />;
        }
        if (errorStatus.includes(actionNumber)) {
            return <AlertLabel type="error" text="Problema QR" width='130px' />;
        }
        return null;
    };

    return (
        <QueryOrderQr numOrder={numOrder}>
            {({ data: orderQr }) => {
                const actionNumber = get(last(orderQr), 'actionNumber', 0);
                const isError = errorStatus.includes(actionNumber);

                return (
                    <>
                        {(actionNumber > 0) && (<>
                            <Text strong text={`Validación puerta: `}/>
                            <Row>
                                {renderAlertButton(actionNumber)}
                                <Button
                                    color='black'
                                    width='250px'
                                    link
                                    text={isError && !wasUnlocked ? 'Desbloquear' : 'Ver detalle'}
                                    onClick={toggleDrawerOrderQr}
                                />
                            </Row>
                        </>)}
                        <Drawer
                            values={['40%', '40%', '100%']}
                            visible={drawerOrderQr}
                            maskClosable
                            onClose={closeDrawerOrderQr}
                        >
                            {drawerOrderQr && (
                                <Column>
                                    <DrawerHeader 
                                        title={getDrawerOrderQrTitle(actionNumber)} 
                                        onClose={closeDrawerOrderQr} 
                                        titleProps={{ style: { fontWeight: 'bold', fontSize: '1.15rem', } }} 
                                    />
                                    <OrderQr
                                        dataQr={orderQr}
                                        id={id}
                                        storeName={storeName}
                                        isErrorQr={isError && !wasUnlocked}
                                        onClose={closeDrawerOrderQr}
                                        isBipicking={isBipicking}
                                        relatedOrderId={relatedOrderId}
                                        onUnlocked={handleUnlocked}
                                    />
                                </Column>
                            )}
                        </Drawer>
                    </>
                );
            }}
        </QueryOrderQr>
    );
};

OrderQrStatus.propTypes = {
    numOrder: string,
    storeName: string,
    id: string,
    isBipicking: bool,
    relatedOrderId: string,
    firebase: object,
};

OrderQrStatus.defaultProps = {
    numOrder: '0',
};

export default withFirebase(OrderQrStatus);